import { INITIAL_STATE } from "./moduleRGPlaybackState";

export default {
  SET_IS_INITIAL(state, data) {
    state.isInitial = data;
  },

  SET_PLAYBACK_SETTINGS(state, data) {
    state.playbackSettings = data;
  },

  SET_IS_ACTIVE_DATE_INPUT_DIALOG(state, data) {
    state.isActiveDateInputDialog = data;
  },

  SET_PLAYBACK_TIME_NOW(state, data) {
    state.playbackSettings.now = data;
  },

  SET_RG_PLAYBACK_STATUS(state, data) {
    state.playbackSettings.playbackStatus = data;
  },

  SET_PLAYBACK_SECONDS_PER_FRAME(state, data) {
    state.playbackSettings.secondsPerFrame = data;
  },

  SET_RG_PLAYBACK_OBJECTS(state, data) {
    state.rgPlaybackObjects = data;
  },

  SET_LAYER_FILTERS(state, data) {
    state.layerFilters = data;
  },

  SET_VISIBLE_TRACKS(state, data) {
    state.visibleTracks = data;
  },

  SET_VISIBLE_TRACKS_RG_OBJECT(state, data) {
    state.visibleTracks.rgObject = data;
  },

  RESET_VISIBLE_TRACKS(state) {
    state.visibleTracks = {
      vessels: [],
      rgObject: [],
    };
  },

  SET_RG_PLAYBACK_PRIVATE_PLOTS(state, data) {
    state.privatePlots = data;
  },

  SET_RG_PLAYBACK_CAMERAS(state, data) {
    state.cameras = data;
  },

  SET_RADAR_CAMERA_MASTERS(state, data) {
    state.radarGridCameraMaster = data;
  },

  // 拡大表示の対象となるRgObjectを追加
  PUSH_EXPAND_IMG_RG_OBJECT(
    state,
    rgObject, // {id: string, src: string, trackNumber: string, aiseaCameraName: string}
  ) {
    state.expandImgRgObjects.push(rgObject);
  },

  // 拡大表示の対象から特定のIDを持つRgObjectを削除
  FILTER_EXPAND_IMG_RG_OBJECT(
    state,
    filterTargetId, // string; 拡大表示の対象から削除するRgObjectのid
  ) {
    state.expandImgRgObjects = state.expandImgRgObjects.filter(
      (rgObject) => rgObject.id !== filterTargetId,
    );
  },

  SET_EXPAND_IMG_RG_OBJECT(
    state,
    nextExpandImgRgObjects, // {id: string, src: string, trackNumber: string, aiseaCameraName: string}[]
  ) {
    state.expandImgRgObjects = nextExpandImgRgObjects;
  },

  RESET_STATE(state) {
    Object.assign(state, INITIAL_STATE);
  },
};
